import { TypedControl } from './controls';
import { TypedForm } from './get-typed-form';

/**
 * Get all controls from typed form
 *
 * @param typedForm
 */
export function getTypedControls(
  typedForm: TypedForm | undefined,
): TypedControl[] {
  const typedControls: TypedControl[] = [];

  if (!typedForm) {
    return typedControls;
  }

  if (typedForm.pages) {
    typedForm.pages.forEach(page => {
      typedControls.push(...page.fields.map(field => field.controls).flat());
    });
  }
  if (typedForm.fields) {
    typedForm.fields.forEach(field => {
      typedControls.push(...field.controls);
    });
  }

  return typedControls;
}

/**
 * Get typed controls, mapped by their names
 *
 * @param typedForm
 */
export function getTypedControlsMap(
  typedForm: TypedForm | undefined,
): Record<string, TypedControl> {
  const typedControls = getTypedControls(typedForm);

  return typedControls.reduce<Record<string, TypedControl>>(
    (acc, typedControl) => {
      acc[typedControl.control.$name] = typedControl;
      return acc;
    },
    {},
  );
}
